import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  ElementRef,
  ViewChild,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';

import { ChildTableA11yService } from '../../services/child-table-a11y.service';

@Component({
  selector: 'child-table-custom-move',
  templateUrl: './child-table-custom-move.component.html',
  styleUrls: ['./child-table-custom-move.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChildTableCustomMoveComponent implements AfterViewInit, OnDestroy {
  @ViewChild('moveInput') moveInput!: ElementRef<HTMLInputElement>;

  @Input() maxRows = 0;
  @Output() move = new EventEmitter<number>();
  @Output() close = new EventEmitter<void>();

  target: number | null = null;
  private focusTrapListener: ((e: KeyboardEvent) => void) | null = null;

  constructor(private readonly a11y: ChildTableA11yService) {}

  get isValid(): boolean {
    return !!this.target && this.target >= 1 && this.target <= this.maxRows;
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.moveInput?.nativeElement?.focus();
      this.initFocusTrap();
    }, 50);
  }

  ngOnDestroy(): void {
    this.destroyFocusTrap();
  }

  submit(): void {
    if (this.isValid) {
      this.move.emit(this.target!);
    }
  }

  onDialogKeydown(e: KeyboardEvent): void {
    if (e.key !== 'Tab') return;

    const dialog = this.moveInput?.nativeElement?.closest('dialog');
    if (!dialog) return;

    this.a11y.trapFocus(e, dialog);
  }

  private initFocusTrap(): void {
    const dialog = this.moveInput?.nativeElement?.closest('dialog');
    if (!dialog) return;

    this.focusTrapListener = (e: KeyboardEvent) => this.onDialogKeydown(e);
    dialog.addEventListener('keydown', this.focusTrapListener);
  }

  private destroyFocusTrap(): void {
    if (!this.focusTrapListener) return;
    const dialog = this.moveInput?.nativeElement?.closest('dialog');
    dialog?.removeEventListener('keydown', this.focusTrapListener);
    this.focusTrapListener = null;
  }
}
